const {
  getSupportedLanguageCodes,
  getSupportedLocaleCodes,
  getSupportedLocaleCodesByLanguage,
  getMainLocaleCodes,
  getMainLocaleFromLanguage,
  getLanguageCodeByLocale,
  getLocaleName,
  getLocaleSpecificName,
  getBrowserLocale,
} = require('./locale')

const {
  getUrlByLocale,
  getDomainMap,
  getLocaleByDomain,
  getDesiredDomainByLanguage,
} = require('./domain')

module.exports = {
  getSupportedLanguageCodes,
  getSupportedLocaleCodes,
  getSupportedLocaleCodesByLanguage,
  getMainLocaleCodes,
  getMainLocaleFromLanguage,
  getLanguageCodeByLocale,
  getLocaleName,
  getLocaleSpecificName,
  getBrowserLocale,
  getUrlByLocale,
  getDomainMap,
  getLocaleByDomain,
  getDesiredDomainByLanguage,
}
